import Form from 'spooner';
import styled from 'styled-components';

export * from 'spooner';

export default styled(Form)``;
